import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { ListAzureSubnets200Response } from '../models/ListAzureSubnets200Response';
import { ListAzureSubnetsRequest } from '../models/ListAzureSubnetsRequest';

/**
 * no description
 */
export class ListAzureSubnetsApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * List subnets in a virtual network
   * @param accountId ID of the restore account
   * @param projectId The project ID
   * @param listAzureSubnetsRequest The request body for listing subnets
   */
  public async listAzureSubnets(accountId: string, projectId: string, listAzureSubnetsRequest: ListAzureSubnetsRequest, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'accountId' is not null or undefined
    if (accountId === null || accountId === undefined) {
      throw new RequiredError("ListAzureSubnetsApi", "listAzureSubnets", "accountId");
    }


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("ListAzureSubnetsApi", "listAzureSubnets", "projectId");
    }


    // verify required parameter 'listAzureSubnetsRequest' is not null or undefined
    if (listAzureSubnetsRequest === null || listAzureSubnetsRequest === undefined) {
      throw new RequiredError("ListAzureSubnetsApi", "listAzureSubnets", "listAzureSubnetsRequest");
    }


    // Path Params
    const localVarPath = '/projects/{projectId}/restore-accounts/{accountId}/azure/subnets'
      .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)))
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.POST, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


    // Body Params
    const contentType = "application/json"
    requestContext.setHeaderParam("Content-Type", contentType);
    const serializedBody = JSON.stringify(ObjectSerializer.serialize(listAzureSubnetsRequest, "ListAzureSubnetsRequest", ""));
    requestContext.setBody(serializedBody);

    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class ListAzureSubnetsApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to listAzureSubnets
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async listAzureSubnetsWithHttpInfo(response: ResponseContext): Promise<HttpInfo<ListAzureSubnets200Response >> {
    if (isCodeInRange("200", response.httpStatusCode)) {
      const body: ListAzureSubnets200Response = ObjectSerializer.deserialize(
        await response.body.json(),
        "ListAzureSubnets200Response", ""
      ) as ListAzureSubnets200Response;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: ListAzureSubnets200Response = await response.body.json() as ListAzureSubnets200Response;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
